export default __webpack_public_path__ + "static/media/icon-caret-down.6e9b97d8.svg";